module.exports = __webpack_public_path__ + "img/RFID打印机.80516573.jpg";